// extracted by mini-css-extract-plugin
export var previewContainer = "_sw-0";